// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"Footer-module__ctaWrapper__DTXB5"};